import { HOW_IT_WORK_GET_LIST,HOW_IT_WORK_GET_LIST_SUCCESS,HOW_IT_WORK_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getHowitWorkList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case HOW_IT_WORK_GET_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case HOW_IT_WORK_GET_LIST_SUCCESS:
            console.log('HOW_IT_WORK_GET_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getHowitWorkList: action.data,
                error: '',
                messages: ''
            };
        case HOW_IT_WORK_GET_LIST_ERROR:
            return {
                ...state,
                loading: false,
                getHowitWorkList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
